import { useMemo } from 'react';

import { FullStoryEvent, FullStoryService, TrackData } from '@fly/shared';
import { PublicVarScope } from '@fullstory/snippet';

export const useFullStory = () => {
  return useMemo(() => {
    const service = FullStoryService.getInstance();
    return {
      init: (devMode = false) => service.init(devMode),
      trackEvent: (name: FullStoryEvent, data?: TrackData) =>
        service.event(name, data || {}),
      trackFunnel: (
        funnelName: string,
        step: number,
        stepName: string,
        extraData?: TrackData
      ) => service.trackFunnel(funnelName, step, stepName, extraData),
      setVars: (namespace: PublicVarScope, data: TrackData) =>
        service.setVars(namespace, data),
      identify: (uid: string, data: TrackData) => service.identify(uid, data),
      trackError: (
        errorType: string,
        error: Error | string,
        context?: TrackData
      ) => service.trackError(errorType, error, context),
      setConsent: (consent: boolean) => service.setConsent(consent),
      isInitialized: () => service.isInitialized(),
    };
  }, []);
};
